module.exports = require('./dist/jstz.js');



//////////////////
// WEBPACK FOOTER
// ./~/jstz/index.js
// module id = 161
// module chunks = 0